import React from "react";
import { Message } from "components/generic/layout";
import { UnsignedLayout } from "components/common/auth";

export default () => (
  <UnsignedLayout>
    <Message
      title="Success!"
      text="You'll receive an email shortly which will allow you to set a new password."
      showIcon
    />
  </UnsignedLayout>
);



// WEBPACK FOOTER //
// ./src/components/pages/Auth/ResetPasswordSuccess/index.js